if (!customElements.get('video-player')) customElements.define('video-player', class VideoPlayer extends HTMLElement {
    constructor() { super(); this.intersectionObserver = null; }

    connectedCallback() {
        const video = this.querySelector('video');
        const playPauseButton = this.querySelector('.controller');
        const hasAutoplay = video.hasAttribute('autoplay');
        
        video.removeAttribute('controls');
        
        // Only set up button if it exists
        if (playPauseButton) {
            playPauseButton.setAttribute('aria-label', 'Play');
        }

        const togglePlayPause = () => {
            const playPromise = video.paused ? video.play() : video.pause();
            if (playPromise !== undefined) {
                playPromise.then(() => {
                    if (playPauseButton) {
                        playPauseButton.setAttribute('aria-label', video.paused ? 'Play' : 'Pause');
                    }
                    this.classList.toggle('playing', !video.paused);
                }).catch(() => {
                    if (playPauseButton) {
                        playPauseButton.setAttribute('aria-label', 'Play');
                    }
                    this.classList.remove('playing');
                });
            }
        };

        const lazyLoad = () => {
            const source = video.querySelector('source[data-src]');
            if (source) {
                source.setAttribute('src', source.getAttribute('data-src'));
                source.removeAttribute('data-src');
                video.load();
            }
        };

        const handleIntersection = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    lazyLoad();
                    // Only autoplay if the video has the autoplay attribute
                    if (hasAutoplay && video.paused) {
                        togglePlayPause();
                    }
                } else {
                    if (!video.paused) {
                        video.pause();
                        if (playPauseButton) {
                            playPauseButton.setAttribute('aria-label', 'Play');
                        }
                        this.classList.remove('playing');
                    }
                }
            });
        };

        this.intersectionObserver = new IntersectionObserver(handleIntersection);
        this.intersectionObserver.observe(this);

        // Only add button listeners if button exists
        if (playPauseButton) {
            playPauseButton.addEventListener('click', togglePlayPause);
        }
        
        if (video.hasAttribute('click-play')) {
            video.addEventListener('click', togglePlayPause);
        }

        video.addEventListener('pause', () => {
            if (playPauseButton) {
                playPauseButton.setAttribute('aria-label', 'Play');
            }
            this.classList.remove('playing');
        });

        video.addEventListener('play', () => {
            if (playPauseButton) {
                playPauseButton.setAttribute('aria-label', 'Pause');
            }
            this.classList.add('playing');
        });
    }

    disconnectedCallback() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = null;
        }
    }
});